import color from './color';

const style = {
    center: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    page: {
        backgroundColor: 'rgb(250, 250, 250)',
    },
    tag: {
        borderRadius: '10px',
        color: color.blurple,
        backgroundColor: color.blurpleAlpha,
        padding: '8px 13px',
    },
    section: {
        borderRadius: '10px',
        border: '1px solid rgb(240, 240, 240)',
        boxShadow: '1px 1px 1px 1px rgb(240, 240, 240)',
        backgroundColor: 'white',
    },
    loginForm: {
        borderRadius: '12px',
        border: '0px',
        boxShadow: '0 0 15px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'white',
    },
    borderTop: {
        borderTopWidth: 1,
        borderTopStyle: 'solid',
        borderTopColor: '#e8e8e8',
    },
    borderBottom: {
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: '#e8e8e8',
    },
};

export default style;
